import React from 'react';
import classnames from 'classnames';

import './index.scss';

// import NoPermissionImg from '@home/assets/img/no-data.png';

interface IPageAccessProps extends IBaseProps {
  isAccess: boolean;
  title?: string | React.ReactElement | null;
  description: string | React.ReactElement | null;
  children: React.ReactElement;
}

const PageAccess: React.FC<IPageAccessProps> = (props) => {
  const { style, className, isAccess = false, title, description = '' } = props;

  if (isAccess) return props.children;
  return (
    <div style={style} className={classnames('dbg-no-permission-page', className, { 'has-title': !!title })}>
      <div className="dbg-no-permission-page__inner">
        {!!title && <div className="dbg-no-permission-page__title">{title}</div>}
        <div className="dbg-no-permission-page__box">
          {/* <img className="dbg-no-permission-page__no-permission-img" src={NoPermissionImg} alt="" />*/}
          <p className="dbg-no-permission-page__desc">{description}</p>
        </div>
      </div>
    </div>
  );
};

export default React.memo(PageAccess);
